import popupKey from './popupKey';
import actions from '../actions';

export default (key, popup) => action =>
  action.type === actions.HIDE_NOTIFICATION &&
  action.key === (popup ? popupKey(key) : key);
